// frontend/src/GiftCards/apiClient.js — thin wrapper around authenticatedFetch for /api/gift-cards (same shape as KlaviyoProfileCleanup/apiClient.js).
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/gift-cards';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const send = (method, path, body) => authenticatedFetch(`${BASE}${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: body === undefined ? undefined : JSON.stringify(body) }).then(jsonOrThrow);
const get = (path) => authenticatedFetch(`${BASE}${path}`).then(jsonOrThrow);
const blob = async (path) => { const r = await authenticatedFetch(`${BASE}${path}`); if (!r.ok) await jsonOrThrow(r); return r.blob(); };

export const gcApi = {
  jobs: () => get('/jobs'),
  job: (id) => get(`/jobs/${id}`),
  create: (body) => send('POST', '/jobs', body),
  checkCodes: (body) => send('POST', '/codes/check', body),
  resume: (id) => send('POST', `/jobs/${id}/resume`),
  refresh: (id) => send('POST', `/jobs/${id}/refresh`),
  clubs: () => get('/clubs'),
  pdf: (id) => blob(`/jobs/${id}/print.pdf`),
  csv: (id) => blob(`/jobs/${id}/cards.csv`),
};

// Opens a blob in a new tab (the PDF) or downloads it (the CSV).
export function openBlob(b, filename, download) {
  const url = URL.createObjectURL(b);
  if (download) { const a = document.createElement('a'); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); }
  else window.open(url, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
